import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../common/Sidebar';
import './AdminLayout.css';

const AdminLayout = () => {
    return (
        <div className="page-container">
            <Sidebar />
            <div className="admin-content">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
